module.exports = __webpack_public_path__ + "img/trolley.453b33c4.svg";